import * as React from "react";

import {IconButton, withStyles} from "@material-ui/core";
import {connect} from 'react-redux';
import {Redirect, Route, RouteComponentProps, Switch, withRouter} from "react-router-dom";
import {compose} from 'redux';
import * as UserActions from '@services/user/user.actions';
import * as RatingActions from '@services/rating/rating.actions';
import {privateMainRoutes} from './router.constants';
import ArticleModal from '@containers/knowledge/article/ArticleModal';
import cordovaContext from "src/cordovaContext";
import PayWall from "@components/common/paywall/PayWall";
import Button from "@components/common/button/Button";
import Dialog from "@components/common/dialog/dialog.component";
import {IFamilyMember} from '@app-types/websocket/family.types';
import {FamilyMemberType} from '@services/family/family.constants';
import {ILogEntry} from '@app-types/websocket/log.types';
import {ISchedule} from '@app-types/websocket/schedule.types';
import CornerRightElements2 from "@components/svg/cornerRightElements2";
import { IEvent } from '@app-types/websocket/event.types';
import { ISharedNote } from '@app-types/websocket/sharedinfo.types';
import { downloadICSData } from "@services/externalCalendar/externalCalendar.actions"; 
import {storeAppToken, updateAppToken} from '@services/user/user.actions';
import { IAppToken, IDeviceData } from '@app-types/websocket/user.types';
import { detectBrowser, getAppTokenPlatform, getOS } from '@helpers/osDetection';
import { IExternalCalendar } from "@app-types/websocket/externalCalender.types";
import TranslateNew from "@translate/TranslateNew";
import CallDisplay from "@components/calls/CallDisplay";
import { isUserInCall } from '@services/calls/calls.utils';
import { clearFirebaseAnalyticsUserId, getFirebaseAppInstanceId, setFirebaseAnalyticsUserId } from '@services/firebase/firebaseAnalytics';
import { getFirebaseAnalyticsContext } from '@services/firebase/firebaseAnalyticsContext';
import { getAttributionTrackingId } from '@services/attribution/attribution';
import { initializeFirebaseOnDeviceMeasurement } from '@services/firebase/firebaseOnDeviceMeasurement';
import { runCordovaPluginCall, runCordovaPluginPromise } from '@helpers/cordovaBridge';
import {PrivateRouterStyle as styles} from './private.router.style';
import StarRoundedIcon from '@material-ui/icons/StarRounded';
import StarBorderRoundedIcon from '@material-ui/icons/StarBorderRounded';
import { INewRating } from '@app-types/websocket/rating.types';


const tn: TranslateNew = TranslateNew.getInstance();
const SETTINGS_LINK_SUFFIX = " SETTINGS_LINK";
const LOGIN_LOADING_DELAY_MESSAGE_MS = 6000;
declare const window: any;



interface IProps extends RouteComponentProps {
  classes: any;
  isAuthentificated: boolean;
  user: any;
  location: any;
  rehydrated: boolean;
  // notifications: any;
  onboardingStep: number;
  displayChatInMobile: boolean;
  // selectedScheduleId: number;
  loadCompleted: boolean;
  loginFailed: boolean;
  inCall: boolean;
  filePickerLoadingScreenSuppressedUntil: number;
  family: IFamilyMember[];
  logEntries: ILogEntry[];
  schedules: ISchedule[];
  events:IEvent[];
  notes:ISharedNote[];

  inviteMem?:IFamilyMember;
  isChild:boolean;
  isParent:boolean;
  isOnline: boolean;
  showRatingPrompt: boolean;

  language:string;
  updateLanguage: (data:{language: string, timeZone:string}) => void;
  storeDeviceData: (data:IDeviceData) => void;
  displayErrorMessage: (msg: string) => void;

  externalCalendars: IExternalCalendar[]; 
  downloadICSEvents: (payload: { url: string; id: number }) => void; 

  selectLanguage: (language: string) => void;

  updateToken: (token: IAppToken) => void;
  storeToken: (token: string) => void;
  setOnboardingstep: (step:number) => void;
  submitRating: (rating: INewRating) => void;
  dismissRatingPrompt: () => void;
  logout: () => void;
}

interface IState {
  downloadICS:Map<number,number>;
  showDelayedRatingPrompt:boolean;
  showLoginLoadingDelayMessage:boolean;
  selectedRating:number|undefined;
  hasShownNotificationPermissionSettingsMessage:boolean;
}

export class PPrivateRouter extends React.Component<IProps, IState> {

  private hasInitializedFirebase = false;
  private hasRequestedFirebaseToken = false;
  private isRequestingFirebaseToken = false;
  private hasSentLanguageUpdate = false;
  private hasSentIDFA = false;
  private syncedFirebaseUserId = "";
  private firebaseTokenRequestTimeout?: number;
  private unauthenticatedRedirectTimeout?: number;
  private loginLoadingDelayMessageTimeout?: number;
  private ratingPromptDelayTimeout?: number;


  constructor(props: any) {
    super(props);
    this.state = {
      downloadICS:new Map<number, number>(),
      showDelayedRatingPrompt:false,
      showLoginLoadingDelayMessage:false,
      selectedRating:undefined,
      hasShownNotificationPermissionSettingsMessage:false,
    };
  }


  public deviceOnline = () => {
    if (this.hasInitializedFirebase) {
      return;
    }

    if (!this.context) {
      return;
    }

    const FirebasePlugin = (globalThis as any).FirebasePlugin;
    if (!FirebasePlugin) {
      console.warn("Firebase plugin not available");
      return;
    }
    this.hasInitializedFirebase = true;

    this.syncFirebaseAnalyticsUser();

    const notificationPlatform = getAppTokenPlatform();

    runCordovaPluginCall("FirebasePlugin.onTokenRefresh", () => FirebasePlugin.onTokenRefresh((refreshToken: any) => {
      // Keep backend token data fresh, but do not mark the permission probe as done.
      this.storeFirebaseMessagingToken(refreshToken, false);
    }));

    if (notificationPlatform === "android") {
      const channel = {
        id: 'incoming_calls',
        name: 'Incoming Calls',
        description: 'Notifications for incoming calls',
        importance: 4, // HIGH - shows as heads-up notification
        sound: 'call1', // without extension
        vibration: true,
        visibility: 0 // PRIVATE
      };

      runCordovaPluginCall("FirebasePlugin.createChannel", () => FirebasePlugin.createChannel(channel));
    }
  }

  public componentDidMount = () => {
    window.scrollTo(0, 0);

    this.deviceOnline();
    this.syncFirebaseMessagingToken();
    this.syncUnauthenticatedRedirect();
    this.syncLoginLoadingDelayMessage();
    this.syncRatingPromptDelay(false);
  };

  public componentDidUpdate(oldProps: IProps) {
    this.syncLoginLoadingDelayMessage();
  
    if (oldProps.showRatingPrompt !== this.props.showRatingPrompt) {
      this.syncRatingPromptDelay(oldProps.showRatingPrompt);
    }
    if (!this.hasInitializedFirebase) {
      this.deviceOnline();
    }
    if (oldProps.user?.id !== this.props.user?.id) {
      this.hasRequestedFirebaseToken = false;
      this.syncFirebaseAnalyticsUser();
      this.syncFirebaseMessagingToken();
    }
    if (oldProps.user?.email !== this.props.user?.email || oldProps.isAuthentificated !== this.props.isAuthentificated) {
      this.syncFirebaseAnalyticsUser();
    }
    if (!oldProps.isOnline && this.props.isOnline) {
      this.syncFirebaseMessagingToken();
    }
    if (oldProps.location.pathname !== this.props.location.pathname) {
      this.syncFirebaseMessagingToken();
    }
    if (oldProps.externalCalendars !== this.props.externalCalendars) {
      const THRESHOLD = 5 * 60 * 1000; 
      const currentTime = Date.now();
  
      const newDownloadedICS = new Map(this.state.downloadICS);
      this.props.externalCalendars.forEach((calendar) => {
        if (calendar.id !== undefined) {
          const lastFetch = newDownloadedICS.get(calendar.id);
          if ((lastFetch === undefined || currentTime - lastFetch > THRESHOLD) 
              && (!calendar.lastFetchedTime || currentTime - calendar.lastFetchedTime > THRESHOLD)) {
            newDownloadedICS.set(calendar.id, currentTime)
            this.props.downloadICSEvents({ url: calendar.url, id: calendar.id });
          }
        }
      });
      this.setState({downloadICS:newDownloadedICS});
    }
  
    if (this.syncUnauthenticatedRedirect()) {
      return;
    }
    if (this.props.isAuthentificated
      && (this.props.location.pathname === "/" || this.props.location.pathname === "/app" || this.props.location.pathname === "/app/")) {
      this.props.history.replace('/app/calendar/:calendarId/:suggestionId');
      return;
    }
    if (this.props.location.pathname.startsWith("/app/onboarding")
      && this.props.onboardingStep !== undefined && (this.props.onboardingStep < 0 || this.props.onboardingStep > 9)) {
      this.props.history.push('/app/calendar/:calendarId/:suggestionId');
      return;
    }
    if (((oldProps.family === undefined || oldProps.family.length === 0)
        && (this.props.family !== undefined && this.props.family.length > 0))
      && !this.props.location.pathname.startsWith("/app/onboarding")) {
      let numParents = 0;
      let numKids = 0;
      for (const mem of this.props.family) {
        if (mem.id === this.props.user.id && mem.role === FamilyMemberType.MODERATOR) {
          break;
        }
        if (mem.role === FamilyMemberType.PARENT) {
          numParents++;
        } else if (mem.role === FamilyMemberType.CHILD) {
          numKids++;
        }
      }


      if ((numParents < 2 ) && numParents > 0 && this.props.isParent) {
        this.props.setOnboardingstep(0);
        this.props.history.replace('/app/onboarding/');
        return;
      }
      if (( numKids < 1) && numParents > 0 && this.props.isParent) {
        this.props.setOnboardingstep(1);
        this.props.history.replace('/app/onboarding/');
        return;
      }
    }

    if (oldProps.logEntries !== this.props.logEntries // to check data is loaded
      && this.props.logEntries !== undefined && this.props.logEntries.length > 0
      && this.props.schedules.length === 0
      && this.props.events.length === 0
      && this.props.notes.length === 0
      && !this.props.location.pathname.startsWith("/app/onboarding")) {
      
      this.props.history.replace('/app/onboarding/');
    }
    if (!this.hasSentLanguageUpdate && this.props.isOnline) {
      this.hasSentLanguageUpdate = true;
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      let lang = this.props.language;
      if (lang === undefined || lang === null || lang.length < 2) {
        const lan = navigator.language? (navigator.language.toLowerCase()) : "";

        if (lan.startsWith("sv")) {
          lang ="SE";
        } else if (lan.startsWith("en")) {
          lang ="EN";
        } else {
          lang ="EN";
        }

        this.props.selectLanguage(lang);
      }
      this.props.updateLanguage({language:lang, timeZone});
    }
    if ((!this.hasSentIDFA) && this.props.location.pathname.startsWith("/app/calendar") && this.props.isOnline) {
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      if (window.device && window.cordova && window.cordova.plugins && window.cordova.plugins.idfa) {
        // Only mark as sent once a branch actually runs, so a deviceready race
        // (cordova present but device/idfa not yet populated) retries on a later update.
        this.hasSentIDFA = true;

        const os = getOS();
        let marketingId: string | undefined ;

        const idfaPlugin = window.cordova.plugins.idfa;

        runCordovaPluginPromise<{trackingLimited:boolean, trackingPermission:number|undefined, idfa: string|undefined, aaid:string|undefined}>(
          "Idfa.getInfo",
          () => idfaPlugin.getInfo()
        )
          .then((info) => {
            if (!info) {
              return;
            }

            if (!info.trackingLimited) {
              marketingId =  info.idfa || info.aaid;
              console.log("Tracking not limited, got marketing ID", marketingId);
            } else if (info.trackingPermission === idfaPlugin.TRACKING_PERMISSION_NOT_DETERMINED) {
              return runCordovaPluginPromise<number>("Idfa.requestPermission", () => idfaPlugin.requestPermission()).then((result) => {
                if (result === idfaPlugin.TRACKING_PERMISSION_AUTHORIZED) {
                  return runCordovaPluginPromise<any>("Idfa.getInfo after permission", () => idfaPlugin.getInfo()).then((info2) => {
                    if (!info2) {
                      return;
                    }
                    marketingId = info2.idfa || info2.aaid;
                    console.log("User granted tracking permission, got marketing ID", marketingId);
                  });
                } else {
                  console.log("User denied tracking permission, cannot get marketing ID");    
                }
                return;
              });
            } else {
              console.log("Tracking limited or permission denied, cannot get marketing ID");
            }
            return;
          })
          .catch((err:any) => {
            console.error("Error getting tracking info", err);
          })
          .finally(() => {
            void this.storeDeviceDataWithFirebaseId({
              platform: os,
              model: window.device.model,
              version: window.device.version,
              marketingId,
              timeZone,
            });
          });

      } else if (!window.cordova) {
        this.hasSentIDFA = true;

        const os = getOS();
        const browserInfo = detectBrowser();
        void this.storeDeviceDataWithFirebaseId({
          platform: os,
          model: browserInfo.name,
          version: browserInfo.version,
          timeZone,
        }, "Cordova device plugin not available, storing limited device data");
      }

      
    }
  }

  public componentWillUnmount() {
    this.clearUnauthenticatedRedirectTimeout();
    this.clearLoginLoadingDelayMessageTimeout();
    this.clearRatingPromptDelayTimeout();
    this.finishFirebaseTokenRequest();
  }

  public render() {
    const {classes} = this.props;

    

    if (this.isLoadingScreenVisible()) {
      return (<><div className="loading">
                <div className={"loadingCircle"}/>
                <CornerRightElements2 viewBox="-40 10 219 212" className={"loadingTopRightCorner"}/>
                
        </div>
        {/* Back logs out, so offer it only once loading is clearly delayed. */}
        {this.state.showLoginLoadingDelayMessage && (
          <div className={classes.loginLoadingRecovery}>
            <div className={classes.loginLoadingDelayMessage} role="status">
              {tn.lang.loginTakingLonger}
            </div>
            <Button type="button" variant="outlined" onClick={this.props.logout}
              className={classes.loginLoadingBackButton}>
              {tn.lang.back}
            </Button>
          </div>
        )}
        </>);
    }

    return (
      <div className={classes.privateRouter} id="privateRouter">
        <PayWall/>
        <CallDisplay/>
        {this.renderRatingPrompt()}
        <div id="page-top"/>
        {this.renderRoutes()}
        <ArticleModal onNavigateToApp={path => this.props.history.push(path)}/>
      </div>
    );
  }

  private renderRoutes = () => {
    return (
      <Switch>
        {privateMainRoutes.map((prop, key) => {
          if (prop.redirect && prop.to) {
            return <Redirect from={prop.path} to={prop.to} key={key} />;
          } else {
            return <Route path={prop.path} component={prop.component as any} key={key} />;
          }
        })}
      </Switch>
    );
  };

  private renderRatingPrompt() {
    if (!this.props.showRatingPrompt || !this.state.showDelayedRatingPrompt) {
      return null;
    }

    const {classes} = this.props;

    return (
      <Dialog
        open={this.props.showRatingPrompt && this.state.showDelayedRatingPrompt}
        onClose={this.props.dismissRatingPrompt}
        fullWidth={true}
        title={<div className={classes.ratingDialogTitle}>{tn.lang.rateAppTitle}</div>}
        content={(
          <div className={classes.ratingDialogContent}>
            <div>{tn.lang.rateAppText}</div>
            <div className={classes.ratingStars}>
              {[1, 2, 3, 4, 5].map((rating) => (
                <IconButton
                  key={rating}
                  className={classes.ratingStarButton}
                  aria-label={tn.lang.rateAppStarLabel(rating)}
                  onClick={() => this.setState({selectedRating:rating})}
                >
                  {this.state.selectedRating !== undefined && rating <= this.state.selectedRating
                    ? <StarRoundedIcon className={classes.ratingStarSelected}/>
                    : <StarBorderRoundedIcon className={classes.ratingStarUnselected}/>}
                </IconButton>
              ))}
            </div>
          </div>
        )}
        actions={(
          <div className={classes.ratingActions}>
            <Button
              onClick={() => this.submitRating(0)}
              variant="outlined"
              className={classes.ratingLaterButton}
            >
              {tn.lang.rateAppLater}
            </Button>
            <Button
              onClick={() => this.submitRating(this.state.selectedRating)}
              variant="contained"
              color="primary"
              disabled={this.state.selectedRating === undefined}
            >
              {tn.lang.rateAppSubmit}
            </Button>
          </div>
        )}
      />
    );
  }

  private submitRating(rating: number|undefined) {
    if (rating === undefined) {
      return;
    }

    this.props.submitRating({
      rating,
      ratingTime: Date.now(),
    });
  }

  private syncRatingPromptDelay(oldShowRatingPrompt: boolean) {
    if (!this.props.showRatingPrompt) {
      this.clearRatingPromptDelayTimeout();
      if (this.state.showDelayedRatingPrompt) {
        this.setState({showDelayedRatingPrompt:false, selectedRating:undefined});
      }
      return;
    }

    if (oldShowRatingPrompt || this.state.showDelayedRatingPrompt || this.ratingPromptDelayTimeout !== undefined) {
      return;
    }

    this.ratingPromptDelayTimeout = window.setTimeout(() => {
      this.ratingPromptDelayTimeout = undefined;
      if (this.props.showRatingPrompt) {
        this.setState({showDelayedRatingPrompt:true});
      }
    }, 2000);
  }

  private clearRatingPromptDelayTimeout() {
    if (this.ratingPromptDelayTimeout !== undefined) {
      window.clearTimeout(this.ratingPromptDelayTimeout);
      this.ratingPromptDelayTimeout = undefined;
    }
  }

  private syncUnauthenticatedRedirect() {
    if (this.props.isAuthentificated || !this.props.rehydrated) {
      this.clearUnauthenticatedRedirectTimeout();
      return false;
    }

    if (this.unauthenticatedRedirectTimeout !== undefined) {
      return true;
    }

    console.warn("Auth missing after rehydrate; waiting briefly before redirect.", {
      pathname: this.props.location?.pathname,
    });

    this.unauthenticatedRedirectTimeout = window.setTimeout(() => {
      this.unauthenticatedRedirectTimeout = undefined;

      if (!this.props.isAuthentificated && this.props.rehydrated) {
        console.log('NOT AUTH REDIRECT');
        this.props.history.replace('/login');
      }
    }, 500);

    return true;
  }

  private clearUnauthenticatedRedirectTimeout() {
    if (this.unauthenticatedRedirectTimeout !== undefined) {
      window.clearTimeout(this.unauthenticatedRedirectTimeout);
      this.unauthenticatedRedirectTimeout = undefined;
    }
  }

  private isLoadingScreenVisible(props: IProps = this.props) {
    const suppressLoadingScreen = props.filePickerLoadingScreenSuppressedUntil > Date.now();
    // After a LOGIN error, schedules from earlier in the snapshot or from a
    // previous connection do not mean we are logged in, so wait for the retry.
    // Not during a call: the loading screen would unmount CallDisplay and drop it.
    const waitingForInitialLoad = !suppressLoadingScreen
      && !props.loadCompleted
      && ((props.loginFailed && !props.inCall) || props.schedules === undefined || props.schedules.length === 0);

    return (!props.isAuthentificated && props.rehydrated) || waitingForInitialLoad;
  }

  private syncLoginLoadingDelayMessage() {
    if (!this.isLoadingScreenVisible()) {
      this.clearLoginLoadingDelayMessageTimeout();
      if (this.state.showLoginLoadingDelayMessage) {
        this.setState({showLoginLoadingDelayMessage:false});
      }
      return;
    }

    if (this.state.showLoginLoadingDelayMessage || this.loginLoadingDelayMessageTimeout !== undefined) {
      return;
    }

    this.loginLoadingDelayMessageTimeout = window.setTimeout(() => {
      this.loginLoadingDelayMessageTimeout = undefined;

      if (!this.isLoadingScreenVisible()) {
        return;
      }

      this.setState({showLoginLoadingDelayMessage:true});
    }, LOGIN_LOADING_DELAY_MESSAGE_MS);
  }

  private clearLoginLoadingDelayMessageTimeout() {
    if (this.loginLoadingDelayMessageTimeout !== undefined) {
      window.clearTimeout(this.loginLoadingDelayMessageTimeout);
      this.loginLoadingDelayMessageTimeout = undefined;
    }
  }

  private syncFirebaseAnalyticsUser() {
    const nextUserId = this.props.user?.id ? `${this.props.user.id}` : "";

    if (this.props.isAuthentificated && this.props.user?.authorization) {
      void initializeFirebaseOnDeviceMeasurement(nextUserId, this.props.user?.email);
    }

    if (nextUserId === this.syncedFirebaseUserId) {
      return;
    }

    this.syncedFirebaseUserId = nextUserId;

    if (nextUserId) {
      void setFirebaseAnalyticsUserId(nextUserId);
    } else {
      void clearFirebaseAnalyticsUserId();
    }
  }

  private syncFirebaseMessagingToken() {
    if (
      !this.context ||
      !this.props.isOnline ||
      this.hasRequestedFirebaseToken ||
      this.isRequestingFirebaseToken ||
      !this.props.user?.id
    ) {
      return;
    }

    if (this.props.location.pathname.startsWith("/app/onboarding")) {
      return;
    }

    const FirebasePlugin = (globalThis as any).FirebasePlugin;
    if (!FirebasePlugin) {
      console.warn("Firebase plugin not available");
      return;
    }

    const notificationPlatform = getAppTokenPlatform();
    this.beginFirebaseTokenRequest();
    const handleToken = (token: any) => {
      this.finishFirebaseTokenRequest();
      this.storeFirebaseMessagingToken(token, true);
    };

    const handleError = (error: any) => {
      console.warn("Could not sync Firebase messaging token", error);
      this.finishFirebaseTokenRequest();
    };

    const getToken = () => {
      try {
        const didStart = runCordovaPluginCall("FirebasePlugin.getToken", () => {
          FirebasePlugin.getToken(handleToken, handleError);
          return true;
        }, false);
        if (!didStart) {
          this.finishFirebaseTokenRequest();
        }
      } catch (error) {
        handleError(error);
      }
    };

    const finishIosWithoutToken = () => {
      console.warn("Notification permission was not granted.");
      this.finishFirebaseTokenRequest();
    };

    // FirebaseX hasPermission is the broad truth: on Android it is false when
    // POST_NOTIFICATIONS is denied or when app notifications are switched off.
    const checkFirebasePermission = (
      onPermission: (hasPermission: boolean) => void,
      onError: (error: any) => void = handleError
    ) => {
      if (typeof FirebasePlugin.hasPermission !== "function") {
        onPermission(false);
        return;
      }

      try {
        const didStart = runCordovaPluginCall("FirebasePlugin.hasPermission", () => {
          FirebasePlugin.hasPermission(onPermission, onError);
          return true;
        }, false);
        if (!didStart) {
          onError(new Error("Firebase permission check skipped because Cordova bridge is unavailable."));
        }
      } catch (error) {
        onError(error);
      }
    };

    // iOS asks FirebaseX before syncing the token; a denied prompt ends the run.
    const requestIosFirebasePermission = () => {
      if (typeof FirebasePlugin.grantPermission !== "function") {
        getToken();
        return;
      }

      try {
        const didStart = runCordovaPluginCall("FirebasePlugin.grantPermission", () => {
          FirebasePlugin.grantPermission((hasPermission: boolean) => {
            if (hasPermission === false) {
              finishIosWithoutToken();
              return;
            }

            getToken();
          }, handleError);
          return true;
        }, false);
        if (!didStart) {
          handleError(new Error("Firebase permission request skipped because Cordova bridge is unavailable."));
        }
      } catch (error) {
        handleError(error);
      }
    };

    const requestIosPermission = () => {
      checkFirebasePermission((hasPermission: boolean) => {
        if (hasPermission) {
          getToken();
          return;
        }

        requestIosFirebasePermission();
      });
    };

    const syncAndroidTokenAfterPermissionHelperError = (error: any) => {
      console.warn("Could not check Android notification permission", error);
      getToken();
    };

    // Android can still provide an FCM token while notifications are disabled.
    // We always sync the token, but warn once when Android will not display notifications.
    const getTokenAndWarnIfAndroidNotificationsDisabled = () => {
      if (typeof FirebasePlugin.hasPermission !== "function") {
        getToken();
        return;
      }

      checkFirebasePermission((hasPermission: boolean) => {
        if (!hasPermission) {
          this.showNotificationPermissionSettingsMessage();
        }

        getToken();
      }, syncAndroidTokenAfterPermissionHelperError);
    };

    const requestAndroidPostNotificationsPermission = () => {
      const diagnostic = (globalThis as any).cordova?.plugins?.diagnostic;
      const diagnosticPermission = diagnostic?.permission?.POST_NOTIFICATIONS;

      // Prefer Diagnostic because it distinguishes "can request" from "settings only".
      if (
        diagnostic &&
        diagnosticPermission &&
        typeof diagnostic.getPermissionAuthorizationStatus === "function" &&
        typeof diagnostic.requestRuntimePermission === "function"
      ) {
        const permissionStatus = diagnostic.permissionStatus || {};
        const isGranted = (status: string) => status === permissionStatus.GRANTED || status === "GRANTED";
        const isDeniedAlways = (status: string) => status === permissionStatus.DENIED_ALWAYS || status === "DENIED_ALWAYS";

        const requestRuntimePermission = () => {
          const didStart = runCordovaPluginCall("Diagnostic.requestRuntimePermission", () => {
            diagnostic.requestRuntimePermission((status: string) => {
              if (isGranted(status)) {
                getTokenAndWarnIfAndroidNotificationsDisabled();
                return;
              }

              if (isDeniedAlways(status)) {
                this.showNotificationPermissionSettingsMessage();
              }
              getToken();
            }, syncAndroidTokenAfterPermissionHelperError, diagnosticPermission);
            return true;
          }, false);
          if (!didStart) {
            syncAndroidTokenAfterPermissionHelperError(new Error("Android notification permission request skipped because Cordova bridge is unavailable."));
          }
        };

        try {
          const didStart = runCordovaPluginCall("Diagnostic.getPermissionAuthorizationStatus", () => {
            diagnostic.getPermissionAuthorizationStatus((status: string) => {
              if (isGranted(status)) {
                getTokenAndWarnIfAndroidNotificationsDisabled();
                return;
              }

              if (isDeniedAlways(status)) {
                this.showNotificationPermissionSettingsMessage();
                getToken();
                return;
              }

              requestRuntimePermission();
            }, syncAndroidTokenAfterPermissionHelperError, diagnosticPermission);
            return true;
          }, false);
          if (!didStart) {
            syncAndroidTokenAfterPermissionHelperError(new Error("Android notification permission check skipped because Cordova bridge is unavailable."));
          }
        } catch (error) {
          syncAndroidTokenAfterPermissionHelperError(error);
        }
        return;
      }

      // Fallback plugin can request the runtime permission, but cannot tell us
      // if Android has permanently blocked the prompt.
      const permissions = (globalThis as any).cordova?.plugins?.permissions;

      if (
        !permissions ||
        typeof permissions.checkPermission !== "function" ||
        typeof permissions.requestPermission !== "function"
      ) {
        // Last resort: missing Android permission helpers must not block token sync.
        getTokenAndWarnIfAndroidNotificationsDisabled();
        return;
      }

      try {
        const permission = permissions.POST_NOTIFICATIONS || "android.permission.POST_NOTIFICATIONS";
        const didStart = runCordovaPluginCall("Permissions.checkPermission", () => {
          permissions.checkPermission(permission, (status: any) => {
            if (status?.hasPermission) {
              getTokenAndWarnIfAndroidNotificationsDisabled();
              return;
            }

            const didStartRequest = runCordovaPluginCall("Permissions.requestPermission", () => {
              permissions.requestPermission(permission, (requestStatus: any) => {
                if (!requestStatus?.hasPermission) {
                  getToken();
                  return;
                }

                getTokenAndWarnIfAndroidNotificationsDisabled();
              }, syncAndroidTokenAfterPermissionHelperError);
              return true;
            }, false);
            if (!didStartRequest) {
              syncAndroidTokenAfterPermissionHelperError(
                new Error("Android notification permission request skipped because Cordova bridge is unavailable."));
            }
          }, syncAndroidTokenAfterPermissionHelperError);
          return true;
        }, false);
        if (!didStart) {
          syncAndroidTokenAfterPermissionHelperError(
            new Error("Android notification permission check skipped because Cordova bridge is unavailable."));
        }
      } catch (error) {
        syncAndroidTokenAfterPermissionHelperError(error);
      }
    };

    const requestAndroidPermission = () => {
      // Android 12 and older do not have the POST_NOTIFICATIONS runtime prompt.
      if (!this.isAndroid13OrNewer()) {
        getToken();
        return;
      }

      checkFirebasePermission((hasPermission: boolean) => {
        if (hasPermission) {
          getToken();
          return;
        }

        requestAndroidPostNotificationsPermission();
      }, syncAndroidTokenAfterPermissionHelperError);
    };

    // Keep platform behavior explicit:
    // iOS asks before token sync; Android warns when disabled but still syncs token.
    if (notificationPlatform === "ios") {
      requestIosPermission();
    } else if (notificationPlatform === "android") {
      requestAndroidPermission();
    } else {
      this.finishFirebaseTokenRequest();
    }
  }

  // Token refresh and permission-driven sync both end here; only the latter
  // marks this run complete so Android settings can still be checked.
  private storeFirebaseMessagingToken(token: any, markRequestComplete: boolean) {
    if (!token || token === '') {
      return;
    }

    this.props.storeToken(token);

    if (markRequestComplete) {
      this.hasRequestedFirebaseToken = true;
    }

    const platform = getAppTokenPlatform();
    if (platform) {
      this.props.updateToken({appToken:token, platform});
    } else {
      console.warn("Could not determine notification token platform.");
    }
  }

  // The snackbar strips SETTINGS_LINK before display and opens native settings on tap.
  private showNotificationPermissionSettingsMessage() {
    if (this.state.hasShownNotificationPermissionSettingsMessage) {
      return;
    }

    this.props.displayErrorMessage(tn.lang.notificationPermissionSettingsMessage+SETTINGS_LINK_SUFFIX);
    this.setState({hasShownNotificationPermissionSettingsMessage:true});
  }

  private isAndroid13OrNewer() {
    const device = (globalThis as any).device;
    const sdkVersion = Number.parseInt(device?.sdkVersion, 10);
    if (Number.isFinite(sdkVersion)) {
      return sdkVersion >= 33;
    }

    const osVersion = Number.parseInt(device?.version, 10);
    if (Number.isFinite(osVersion)) {
      return osVersion >= 13;
    }

    // If Cordova cannot tell us the OS version, prefer the newer Android path.
    return true;
  }

  private beginFirebaseTokenRequest() {
    this.isRequestingFirebaseToken = true;

    if (this.firebaseTokenRequestTimeout !== undefined) {
      window.clearTimeout(this.firebaseTokenRequestTimeout);
    }

    this.firebaseTokenRequestTimeout = window.setTimeout(() => {
      this.isRequestingFirebaseToken = false;
      this.firebaseTokenRequestTimeout = undefined;
    }, 5000);
  }

  private finishFirebaseTokenRequest() {
    this.isRequestingFirebaseToken = false;

    if (this.firebaseTokenRequestTimeout !== undefined) {
      window.clearTimeout(this.firebaseTokenRequestTimeout);
      this.firebaseTokenRequestTimeout = undefined;
    }
  }

  private async storeDeviceDataWithFirebaseId(
    deviceData: IDeviceData,
    logPrefix = "Storing device data"
  ) {
    const [appInstanceId, firebaseAnalytics, trackingId] = await Promise.all([
      getFirebaseAppInstanceId(), getFirebaseAnalyticsContext(), getAttributionTrackingId(),
    ]);
    const dataWithFirebaseId: IDeviceData = {
      ...deviceData,
      appInstanceId,
      firebaseAnalytics,
      trackingId,
    };

    console.log(logPrefix);
    this.props.storeDeviceData(dataWithFirebaseId);
  }

}

PPrivateRouter.contextType = cordovaContext;


export function mapStateToProps(state: any) {
  const sessionData = state.user?.session?.data ?? {};
  const userId: number = sessionData.id ?? 0;

  const family: IFamilyMember[] = state.family?.family ?? [];

  let isChild = false;
  let isParent = false;
  let inviteMem: IFamilyMember | undefined;

  for (const mem of family) {
    if (mem.id === userId) {
      if (mem.role === FamilyMemberType.CHILD) isChild = true;
      if (mem.role === FamilyMemberType.PARENT) isParent = true;
    }
  }

  if (isParent) {
    for (const mem of family) {
      if (
        mem.id !== userId &&
        mem.role === FamilyMemberType.PARENT &&
        (!mem.lastOnline || mem.lastOnline <= 0) &&
        (!mem.inviteTime || mem.inviteTime === 0)
      ) {
        inviteMem = mem;
        break;
      }
    }
  }

  const onboardingStep = state.user?.onboarding?.activeStep ?? 0;

  const auth = sessionData.authorization;
  const isAuthentificated = typeof auth === "string" && auth.length > 0;

  const isOnline = state.connection.loadCompleted;

  const resources = sessionData.resources ?? [];
  const selectedFamilyIndex = Number.isInteger(state.user?.session?.selectedFamily)
    ? state.user.session.selectedFamily
    : 0;

  let myFamilyId = 0;
  if (Array.isArray(resources) && selectedFamilyIndex >= 0 && selectedFamilyIndex < resources.length) {
    myFamilyId = resources[selectedFamilyIndex]?.id ?? 0;
  }

  let externalCalendars: IExternalCalendar[] = state.externalCalendar?.externalCalendars ?? [];
  externalCalendars = externalCalendars.filter((cal) => cal.familyId === myFamilyId && myFamilyId > 0);
  const rehydrated = !!state._persist?.rehydrated;

  return {
    rehydrated,
    onboardingStep,
    isAuthentificated,
    user: sessionData,
    displayChatInMobile: state.chat?.displayChatInMobile ?? false,
    // selectedScheduleId: state.user?.selectedScheduleId ?? 0,
    loadCompleted: !!state.connection?.loadCompleted,
    loginFailed: !!state.connection?.loginFailed,
    inCall: Array.isArray(state.calls?.calls)
      && state.calls.calls.some((call: any) => !!call && isUserInCall(call, userId)),
    filePickerLoadingScreenSuppressedUntil: typeof state.file?.filePickerLoadingScreenSuppressedUntil === "number"
      ? state.file.filePickerLoadingScreenSuppressedUntil
      : 0,
    family,
    logEntries: state.logs?.logEntries ?? [],
    schedules: state.schedule?.schedules ?? [],
    events: state.event?.events ?? [],
    notes: state.notes?.sharedNotes ?? [],
    isChild,
    isParent,
    inviteMem,
    externalCalendars,
    isOnline,
    language: state.user?.language ?? "EN",
    showRatingPrompt: state.rating?.showRatingPrompt === true,
  };
}




const mapDispatchToProps = {
  downloadICSEvents: downloadICSData,
  updateLanguage: UserActions.storeLanguage,
  selectLanguage: UserActions.selectLanguage,
  storeDeviceData: UserActions.storeDeviceData,
  displayErrorMessage: UserActions.displayErrorMessage,
  updateToken: updateAppToken,
  storeToken: storeAppToken,
  setOnboardingstep: UserActions.onboardingSetActiveStep,
  submitRating: RatingActions.submitRating,
  dismissRatingPrompt: RatingActions.dismissRatingPrompt,
  logout: UserActions.logout,
};

export default compose(
  withRouter,
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(PPrivateRouter);



// WEBPACK FOOTER //
// ./src/router/private.router.tsx